import React from 'react';

interface VarientSkeletonProps {
  featuresCount?: number;
  itemCount?: number;
}

export default function VarientSkeleton({
  featuresCount = 1,
  itemCount = 4,
}: VarientSkeletonProps) {
  return (
    <div className="min-h-[70px]">
      {[...Array(featuresCount)].map((_, featureIndex) => (
        <div key={featureIndex}>
          <div className="mt-3 h-[18px] w-[100px] animate-pulse overflow-hidden rounded bg-silver-400" />
          <div className="flex gap-3">
            {[...Array(itemCount)].map((_, itemIndex) => (
              <div
                key={itemIndex}
                className="mt-3 h-8 w-[72px] animate-pulse overflow-hidden rounded bg-silver-400"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
